@switch (engine) {
  @case ("tiny") {
    <div
      tinyeditor
      [init]="tinyEditorOptions()"
      [maxImageSize]="maxImageSize"
      [containerMode]="containerMode"
      [readOnly]="readOnly"
      class="flex-1"
      (contentChanged)="contentChanged.emit()"
    ></div>
  }
  @case ("devx") {
    <dx-html-editor
      [value]="initialContent"
      [toolbar]="devxEditorToolbar()"
      [placeholder]="placeholder"
      [readOnly]="readOnly"
      class="flex-1 bg-white"
      (onContentReady)="onDevxContentReady($event)"
      (valueChange)="contentChanged.emit()"
    >
      @if (variablesEnabled()) {
        <dxo-variables
          [dataSource]="variablesDataSource()"
          [escapeChar]="variablesEscapeChar()"
        ></dxo-variables>
      }
    </dx-html-editor>
  }
}
